import React, { useState, useEffect, useContext } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import './StickyHeader.scss';
import PrevArrow from '../../../../assets/smartxonnect/PrevArrow.svg';
import { LayoutDetailsContext } from '../../../Project/Layouts/LayoutDetailsContext';

const HeaderSection = (props) => {
  const brandName = useContext(LayoutDetailsContext);
  return (
    <section className="sticky-header">
      <Container fluid className="header-container">
        <Row className="header-row">
          <Col className="header-col">
            <div className="header-content">
              <div className="left-content">
                <img
                  className="back-button"
                  src={PrevArrow}
                  alt="Back"
                  onClick={() => (window.location.href = props.fields?.BackButtonCta?.value?.href)}
                />
                <a href={props.fields?.BackButtonCta?.value?.href} className="logo-link">
                  <img
                    className="logo"
                    src={props.fields?.HeaderIcon?.value?.src}
                    alt={props.fields?.HeaderIcon?.value?.alt}
                  />
                </a>
                <div className="models-text">{props.fields?.heading?.value}</div>
              </div>
              <div className="right-content">
                <a
                  href={props.fields?.BookiQubeCta?.value?.href}
                  className="header-button book-button"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    dataLayer.push({
                      event: 'book_iqube_cta',
                      eventAction: 'Book iQube',
                      BrandName: 'TVS iQube',
                      VariantName: brandName,
                    })
                  }
                >
                  Book iQube
                </a>
                <a
                  href={props.fields?.TestRideCta?.value?.href}
                  className="header-button test-button"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() =>
                    dataLayer.push({
                      event: 'test_ride_click',
                      eventAction: 'Test Ride',
                      BrandName: 'TVS iQube',
                      VariantName: brandName,
                    })
                  }
                >
                  Test Ride
                </a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default React.memo(HeaderSection);
